


































import { defineComponent, computed } from '@vue/composition-api';
import type { PropType } from '@nuxtjs/composition-api';
import type { ProductVariant } from '~/utils/ct/types/product/ProductVariant';
import {
  getProductAttributesExtended,
} from '~/helpers/product/getProductAttributesExtended';
import { useProductDetails } from '~/composables';
import { ProductProcessedAttributes } from '~/types/product/attribute/ProductProcessedAttributes';
import { SCHEMA_ITEM_PROP, SCHEMA_ITEM_TYPE } from '~/constants/seo';
import { PRODUCT_ATTRIBUTES } from '~/constants/products';

export default defineComponent({
  name: 'ProductDetailsMetaSchema',
  props: {
    product: {
      type: Object as PropType<ProductVariant>,
      required: true,
    },
    attributesLocalized: {
      type: Object as PropType<ProductProcessedAttributes>,
      required: true,
    },
  },
  setup(props) {
    const { shippingHeight, shippingWidth, shippingDepth, shippingWeight } = useProductDetails(props.product);

    const brand = computed(() => props.attributesLocalized?.brand);
    const releaseDate = computed(() =>
      getProductAttributesExtended(
        props.product,
        {
          attributeNames: [PRODUCT_ATTRIBUTES.RELEASE_DATE],
        },
      )[PRODUCT_ATTRIBUTES.RELEASE_DATE],
    );
    return {
      shippingHeight,
      shippingWidth,
      shippingDepth,
      shippingWeight,
      brand,
      releaseDate,
      SCHEMA_ITEM_TYPE,
      SCHEMA_ITEM_PROP,
    };
  },
});
